import React, { type FC } from "react";

import { HealthStateValue } from "~/models/dto";
import { cx } from "~/tools/class-variance";

import { healthStateToBackgroundColorToken } from "../../../common/functions";
import type { Api } from "../../../common/openapi";
import { type IconSize, getSizeForIcon } from "../icon/IconSizes";

export interface StateIconProps {
	iconNode?: React.ReactNode;
	iconSize?: IconSize;
	icon?: string;
	disabled?: boolean;
	healthStateValue?: HealthStateValue | Api.HealthStateValue;
	displayType?: "component" | "group";
}

export const StateIcon: FC<StateIconProps> = ({
	iconNode,
	icon,
	iconSize = "default",
	disabled,
	healthStateValue = HealthStateValue.Unknown,
	displayType = "component",
}) => {
	const componentStyle = () => {
		const size = getSizeForIcon(iconSize);
		const style = {
			width: size,
			height: size,
		};

		if (disabled) {
			return style;
		}

		return {
			...style,
			backgroundColor: `var(${healthStateToBackgroundColorToken(healthStateValue)})`,
		};
	};

	const stateIcon = icon ? <img alt="icon" className="block h-1/2 w-1/2" src={icon} /> : iconNode;

	return (
		<div
			className={cx(
				"flex shrink-0 items-center justify-center rounded-sm",
				displayType === "component" ? "rounded-sm" : "rounded-full",
			)}
			data-testid="state-icon"
			style={componentStyle()}
		>
			{stateIcon}
		</div>
	);
};
